import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/school-settings/day/edit')({
  // TODO: Implement the edit school day view - https://panowie.atlassian.net/browse/RG-381
  component: () => <>school day - edit</>,
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.edit-school-day', { ns: 'schoolSettings' })
    ])
})
